import { render } from "./UserType.vue?vue&type=template&id=6132f1e1&ts=true"
import script from "./UserType.vue?vue&type=script&lang=ts"
export * from "./UserType.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-base-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__